import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import { handleSessionExpired } from './utils/api'

const INACTIVITY_LIMIT_MS = 30 * 60 * 1000
const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll', 'wheel']

function updateLastActivity() {
  try {
    localStorage.setItem('aftalink_last_activity', String(Date.now()))
  } catch {
    // ignore
  }
}

function startInactivityTimer() {
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateLastActivity()
  })
  ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, updateLastActivity, { passive: true }))

  setInterval(() => {
    try {
      if (router.currentRoute.value.name === 'login') return
      const last = parseInt(localStorage.getItem('aftalink_last_activity') || '0', 10)
      if (!last) return
      const now = Date.now()
      if (now - last > INACTIVITY_LIMIT_MS) {
        handleSessionExpired()
      } else if (store.state.token) {
        const lastTokenRefresh = parseInt(localStorage.getItem('aftalink_last_token_refresh') || '0', 10)
        if (now - lastTokenRefresh > 30 * 60 * 1000) {
          store.dispatch('refreshToken').then((success) => {
            if (success) localStorage.setItem('aftalink_last_token_refresh', String(now))
          }).catch(() => {})
        }
      }
    } catch (err) {
      console.error('Inactivity check error', err)
    }
  }, 60 * 1000)

  updateLastActivity()
}

createApp(App).use(store).use(router).mount('#app')
startInactivityTimer()
